// STANDARD AI interview — the parts of a library → screening copy that only
// apply to a fixed question list. Rubric-based lives in ./rubric.js.

const DEFAULT_EXPECTATION = 'Answer should be relevant to the role.';

export const TYPE = 'standard';

export function buildQuestionFields(template) {
  const questions = Array.isArray(template?.questions) ? template.questions : [];
  return {
    questions: questions.map((q) => ({
      prompt: q.prompt,
      section: q.section || 'core',
      type: q.type === 'yes_no' ? 'yes_no' : 'short',
      expectedAnswer: q.expectedAnswer || q.scoringGuidance || DEFAULT_EXPECTATION,
      expectedPoints:
        Array.isArray(q.expectedPoints) && q.expectedPoints.length > 0
          ? q.expectedPoints
          : q.scoringGuidance
            ? [q.scoringGuidance]
            : [DEFAULT_EXPECTATION],
      critical: Boolean(q.critical),
    })),
    rubrics: [],
    maxQuestions: questions.length,
  };
}

export function hasQuestions(template) {
  return Array.isArray(template?.questions) && template.questions.length > 0;
}
